import axiosInstance from '../utils/AxiosConfig';

export const getResources = async (locationId) => {
  const response = await axiosInstance.get('/resources', {
    params: {
      locationId: locationId
    }
  });
  return response.data.data;
};

export const addResource = async (resourceRequest) => {
  const response = await axiosInstance.post('/resources', resourceRequest);
  return response.data.data;
};

export const updateResource = async (id, resourceRequest) => {
  const response = await axiosInstance.put(`/resources/${id}`, resourceRequest);
  return response.data.data;
};

export const deleteResource = async (resourceId) => {
  const response = await axiosInstance.delete(`/resources/${resourceId}`);
  return response.data.data;
};